import React from 'react';
import { motion } from 'framer-motion';
import { FracturedHalo } from './FracturedHalo';
import { Globe } from 'lucide-react';
import { FloatingOrbs } from './FloatingOrbs';
export const Footer: React.FC = () => {
  return <footer className="bg-deep-navy/80 backdrop-blur-sm py-16 relative overflow-hidden border-t border-deploid-purple/20" data-id="element-269">
      {/* Final subtle sunrise glow at bottom */}
      <motion.div className="absolute bottom-0 left-0 right-0 h-[15vh] pointer-events-none" style={{
      background: 'radial-gradient(ellipse 80% 60% at 50% 100%, rgba(250, 255, 49, 0.015) 0%, transparent 70%)',
      opacity: 0.6
    }} data-id="element-270" />

      {/* Top glow for transition from content */}
      <motion.div className="absolute top-0 left-0 right-0 h-[20vh] pointer-events-none" style={{
      background: 'radial-gradient(ellipse 100% 60% at 50% 0%, rgba(250, 255, 49, 0.06) 0%, transparent 60%)',
      opacity: 0.6
    }} data-id="element-271" />

      {/* Ambient yellow glow throughout footer */}
      <div className="absolute inset-0 pointer-events-none opacity-20" data-id="element-272">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-electric-yellow/8 rounded-full blur-3xl" data-id="element-273" />
      </div>

      <div className="container mx-auto px-4 md:px-6 relative z-10" data-id="element-274">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10" data-id="element-275">
          <div className="md:col-span-2" data-id="element-276">
            <motion.div className="flex items-center mb-6" initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} transition={{
            duration: 0.6
          }} viewport={{
            once: true
          }} data-id="element-277">
              <img src="https://cdn.magicpatterns.com/uploads/t471sDbF2VBxjAtFRAw9HW/LOGO-A1.png" alt="Deploid" className="h-10 w-auto" data-id="element-278" />
            </motion.div>
            <motion.p className="text-white/70 max-w-md mb-8" initial={{
            opacity: 0
          }} whileInView={{
            opacity: 1
          }} transition={{
            duration: 0.6,
            delay: 0.2
          }} viewport={{
            once: true
          }} data-id="element-279">
              <span className="font-display text-electric-yellow" data-id="element-280">DEPLOID</span>{' '}
              designs, builds, and evolves intelligent business systems across
              CRM, ERP, AI, and bespoke solutions — from architecture to
              integrations, analytics, and intelligence.
            </motion.p>
            <motion.div className="flex space-x-4" initial={{
            opacity: 0,
            y: 10
          }} whileInView={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.6,
            delay: 0.4
          }} viewport={{
            once: true
          }} data-id="element-281">
              <a href="#" className="text-white/70 hover:text-electric-yellow transition-colors text-sm" data-id="element-282">
                LinkedIn
              </a>
            </motion.div>
          </div>
          <div data-id="element-283">
            <motion.h4 className="text-white font-heading font-semibold text-lg mb-4" initial={{
            opacity: 0
          }} whileInView={{
            opacity: 1
          }} transition={{
            duration: 0.6
          }} viewport={{
            once: true
          }} data-id="element-284">
              Services
            </motion.h4>
            <motion.ul className="space-y-3" initial={{
            opacity: 0,
            y: 10
          }} whileInView={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.6,
            delay: 0.2
          }} viewport={{
            once: true
          }} data-id="element-285">
              {['System Architecture', 'CRM & ERP Delivery', 'Integration & Data', 'AI & Automation', 'Evolution & Optimisation'].map((service, index) => <li key={index} data-id="element-286">
                  <a href="#" className="text-white/70 hover:text-electric-yellow transition-colors text-sm" data-id="element-287">
                    {service}
                  </a>
                </li>)}
            </motion.ul>
          </div>
          <div data-id="element-288">
            <motion.h4 className="text-white font-heading font-semibold text-lg mb-4" initial={{
            opacity: 0
          }} whileInView={{
            opacity: 1
          }} transition={{
            duration: 0.6
          }} viewport={{
            once: true
          }} data-id="element-289">
              Contact
            </motion.h4>
            <motion.ul className="space-y-3" initial={{
            opacity: 0,
            y: 10
          }} whileInView={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.6,
            delay: 0.2
          }} viewport={{
            once: true
          }} data-id="element-290">
              <li data-id="element-291">
                <a href="mailto:sales@deploid.com" className="text-white/70 hover:text-electric-yellow transition-colors text-sm" data-id="element-292">
                  sales@deploid.com
                </a>
              </li>
              <li className="flex items-start gap-2" data-id="element-293">
                <Globe className="w-4 h-4 text-white/70 mt-0.5 flex-shrink-0" data-id="element-294" />
                <span className="text-white/70 text-sm" data-id="element-295">Singapore</span>
              </li>
              <li className="flex items-start gap-2" data-id="element-296">
                <Globe className="w-4 h-4 text-white/70 mt-0.5 flex-shrink-0" data-id="element-297" />
                <span className="text-white/70 text-sm" data-id="element-298">Australia</span>
              </li>
            </motion.ul>
          </div>
        </div>
        <div className="thin-divider my-10" data-id="element-299" />
        <div className="flex flex-col md:flex-row justify-between items-center" data-id="element-300">
          <motion.p className="text-white/50 text-sm mb-4 md:mb-0" initial={{
          opacity: 0
        }} whileInView={{
          opacity: 1
        }} transition={{
          duration: 0.6
        }} viewport={{
          once: true
        }} data-id="element-301">
            © 2026 <span className="font-display" data-id="element-302">DEPLOID</span>. All rights
            reserved.
          </motion.p>
          <motion.div className="flex space-x-6" initial={{
          opacity: 0
        }} whileInView={{
          opacity: 1
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} viewport={{
          once: true
        }} data-id="element-303">
            {['Privacy Policy', 'Terms of Service', 'Cookie Policy'].map((link, index) => <a key={index} href="#" className="text-white/50 hover:text-white/80 transition-colors text-sm" data-id="element-304">
                  {link}
                </a>)}
          </motion.div>
        </div>
      </div>
      <div className="absolute bottom-6 right-6 opacity-40 animate-spin-slow" data-id="element-305">
        <FracturedHalo size={60} segments={5} opacity={0.6} animate={false} color="#4f0c9a" data-id="element-306" />
      </div>
    </footer>;
};